/**
 * Predefined industry suggestions for team settings
 */
export const INDUSTRY_SUGGESTIONS = [
  'Technology',
  'SaaS',
  'E-commerce',
  'Healthcare',
  'Finance',
  'Real Estate',
  'Education',
  'Food & Beverage',
  'Travel & Tourism',
  'Fashion & Beauty',
  'Fitness & Wellness',
  'Marketing & Advertising',
  'Media & Entertainment',
  'Non-Profit',
  'Automotive',
  'Construction',
  'Legal',
  'Consulting',
  'Retail',
  'Manufacturing',
  'Hospitality',
  'Agriculture',
  'Energy',
  'Telecommunications',
  'Gaming',
  'Sports',
  'Music',
  'Art & Design',
  'Photography',
  'Coaching',
] as const;

export type Industry = (typeof INDUSTRY_SUGGESTIONS)[number];
